import Model from './Model';

export default class Survey extends Model {
    survey_template_id
    survey_template
    started
    answers
}



// WEBPACK FOOTER //
// ./src/models/Survey.js